// The customer-facing brand name, in one place. Deliberately not the internal name: metric and
// queue prefixes, `marrylyEntityId` and bucket names stay, since renaming them is a migration.
export const BRAND = "Marryly Match";

// Customer-facing support inbox.
export const SUPPORT_EMAIL = "support@marrylymatch.com";

// The marketing site, no trailing slash. Editorial and legal pages live there, so footer links are absolute and cross-origin.
export const SEO_SITE_LINK = "https://marrylymatch.com";

// The brand's public social profiles, in the order the footer lists them.
export const SOCIAL_LINKS = [
  { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61594248782132" },
] as const;
